import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as types from 'hellospa/page/prep-and-send/data/types';
import { defineMessages, useIntl } from 'react-intl';
import SavingBackToDropbox from 'hellospa/components/deep-integration/webflow-states/saving-back-to-dropbox';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as deepIntegrationActions from 'hellospa/page/prep-and-send/data/actions/deep-integration';

import styles from '../index.scss';
import ErrorPage, { ErrorTypes } from '../error-page';

const DeepIntegrationFinalLoading: types.WorkflowComponent = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const user = useSelector(selectors.getUser);
  const integration = useSelector(selectors.getIntegration);
  const saveBackError = useSelector(selectors.getDeepIntegrationError);
  const transmissionGroupGuid = useSelector(selectors.getTransmissionGroupGuid);
  const filename = useSelector(selectors.getExternalFilename);
  const isSelfSign = useSelector(selectors.isDeepIntegrationSelfSign);

  if (!user || !user.email) {
    throw new Error('No user email found!');
  }

  if (!integration) {
    throw new Error('Deep Integration not found in flag.integration');
  }

  if (!filename) {
    throw new Error('Deep Integration filename was not set!');
  }

  React.useEffect(() => {
    dispatch(deepIntegrationActions.pollSavingBackToDropboxStatus(
      transmissionGroupGuid,
    ));
  }, [dispatch, transmissionGroupGuid]);

  if (saveBackError !== undefined) {
    return <ErrorPage
      message={intl.formatMessage(saveBackError.errorTitle)}
      instructions={intl.formatMessage(saveBackError.errorInstructions)}
      type={ErrorTypes.SaveBack} />;
  } else {
    return (
      <div className={styles.loadingContainer}>
        <SavingBackToDropbox filename={filename} isSelfSign={isSelfSign} />
      </div>
    );
  }
};

DeepIntegrationFinalLoading.getText = () => {
  return defineMessages({
    next: {
      id: '',
      description: 'A button in the navigation bar that takes you to the next step',
      defaultMessage: 'Send for signature',
    },
  });
};

export default DeepIntegrationFinalLoading;
